import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";

export default function AdminRoute({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/admin/check")
      .then(res => setIsAdmin(res.data.is_admin))
      .catch(() => setIsAdmin(false));
  }, [user]);

  if (authLoading || isAdmin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-[#6B6B70]">Loading…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/" replace />;
  if (!isAdmin) return <Navigate to="/find" replace />;

  // Admin is still a user — must accept legal + complete onboarding.
  if (user.legal_acceptance?.required !== false) {
    return <Navigate to="/accept-legal" replace />;
  }
  if (user.onboarding_complete === false) {
    return <Navigate to="/profile/setup" replace />;
  }

  return children;
}